import React from "react";
import logo from "../Assets/green.png"; // adjust path if needed

const TermsConditions = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
  };

  const contentStyle = {
    maxWidth: "800px",
    width: "100%",
    fontFamily: "Arial, sans-serif",
  };

  const textStyle = {
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#555",
  };

  const headingStyle = {
    fontSize: "20px",
    marginTop: "20px",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <img
          src={logo}
          alt="Logo"
          style={{ width: "120px", marginBottom: "20px" }}
        />

        <h1 style={{ fontSize: "32px", marginBottom: "20px" }}>
          Terms & Conditions
        </h1>

        <p style={textStyle}>
          By accessing and using this application, you agree to comply with and
          be bound by the following terms and conditions.
        </p>

        <h2 style={headingStyle}>1. Use of Service</h2>
        <p style={textStyle}>
          This application is provided for educational and informational purposes.
          You agree to use the app only for lawful purposes and in a way that does
          not infringe the rights of others.
        </p>

        <h2 style={headingStyle}>2. Content</h2>
        <p style={textStyle}>
          All content, including questions, text, and materials, is the property
          of this platform and may not be copied, reproduced, or redistributed
          without permission.
        </p>

        <h2 style={headingStyle}>3. Advertisements</h2>
        <p style={textStyle}>
          This application displays advertisements provided by third-party
          services such as Google Ads. We are not responsible for the content,
          accuracy, or practices of these advertisements.
        </p>

        <h2 style={headingStyle}>4. Third-Party Links</h2>
        <p style={textStyle}>
          Advertisements or content may contain links to third-party websites.
          We do not control or take responsibility for the content or policies
          of these external sites.
        </p>

        <h2 style={headingStyle}>5. Limitation of Liability</h2>
        <p style={textStyle}>
          We are not liable for any direct, indirect, or incidental damages
          resulting from the use or inability to use this application.
        </p>

        <h2 style={headingStyle}>6. Changes to Terms</h2>
        <p style={textStyle}>
          We may update these Terms & Conditions at any time. Continued use of
          the app after changes means you accept the updated terms.
        </p>

        <h2 style={headingStyle}>7. Termination</h2>
        <p style={textStyle}>
          We reserve the right to suspend or terminate access to the application
          at our discretion, without prior notice.
        </p>

        <h2 style={headingStyle}>8. Contact</h2>
        <p style={textStyle}>
          If you have any questions, contact us at: support@tabsul.me
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;